import React, { useState, useRef } from "react";
import { Tag, Typography, Input, Button, Tabs } from "antd";
import { SearchOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import PrimaryNav from "../../shared/PrimaryNav";
import PageHeader from "../../shared/PageHeader";
import sampleTMCBooking from "./sampleTMCBooking.json";
import sampleTMCBookingWork from "./sampleTMCBookingWork.json";
import AgTableClient from "../../shared/AgTable/AgTableClient";

const columnDefs1 = [
  {
    headerName: "Document No",
    valueGetter: (p) => p.data["Document\n No."],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "Customer No",
    valueGetter: (p) => p.data["Customer\n No."],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Document Date",
    headerName: "Document Date",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Basic",
    headerName: "Basic",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    field: "YQ",
    headerName: "YQ",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    field: "YR",
    headerName: "YR",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    field: "K3",
    headerName: "K3",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    field: "OT",
    headerName: "OT",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    field: "Service Fee",
    headerName: "Service Fee",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    field: "Payments processing fees",
    headerName: "Payments processing fees",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    headerName: "Visa Fee",
    valueGetter: (p) => p.data["Visa\nFee"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    headerName: "Other Fee",
    valueGetter: (p) => p.data["Other\nFee"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    field: "CGST",
    headerName: "CGST",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    field: "SGST",
    headerName: "SGST",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    field: "IGST",
    headerName: "IGST",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    field: "Discount",
    headerName: "Discount",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    headerName: "Airline Cancellation Charge",
    valueGetter: (p) => p.data["Airline\n Cancellation\n Charge"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    field: "Amount",
    headerName: "Amount",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    field: "CTA Amt",
    headerName: "CTA Amt",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    field: "Diff",
    headerName: "Diff",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    field: "Name of Passenger",
    headerName: "Name of Passenger",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
    formatType: "PERSON",
  },
  {
    field: "TypeofTravelService",
    headerName: "Type of Travel Service",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "GDS PNR",
    headerName: "GDS PNR",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Ticket Number",
    headerName: "Ticket Number",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Sector",
    headerName: "Sector",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Name of the Airline",
    headerName: "Name of the Airline",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Date of Travel",
    headerName: "Date of Travel",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "TR No",
    headerName: "TR No",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Gro Emp No",
    headerName: "Gro Emp No",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Department",
    headerName: "Department",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "GRO Order No",
    headerName: "GRO Order No",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Cost Centre",
    headerName: "Cost Centre",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Reason Trip",
    headerName: "Reason Trip",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "Document Reference (In the case of a related document)",
    valueGetter: (p) =>
      p.data["Document Reference\n(In the case of a related document)"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "BCD Remarks",
    headerName: "BCD Remarks",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Pyment - CC pprovl code",
    headerName: "Payment - CC Approval Code",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Pyment - CC UTP pprovl code",
    headerName: "Payment - CC UTP Approval Code",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
];

const columnDefs2 = [
  {
    field: "Agency - Main",
    headerName: "Agency - Main",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Agency - Main"],
  },
  {
    field: "DOC - Number",
    headerName: "DOC - Number",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["DOC - Number"],
  },
  {
    field: "DOC - Date",
    headerName: "DOC - Date",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["DOC - Date"],
  },
  {
    field: "Customer",
    headerName: "Customer",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Document customer name",
    headerName: "Document customer name",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Document customer name"],
    formatType: "ENTITY",
  },
  {
    field: "Prod - Arrival Location",
    headerName: "Prod - Arrival Location",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    hide: true,
    valueGetter: (p) => p.data["Prod - Arrival Location"],
  },
  {
    field: "Arrival Country",
    headerName: "Arrival Country",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Product code description ‘Setup’",
    headerName: "Product code description ‘Setup’",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Product code description ‘Setup’"],
  },
  {
    field: "Prod - Ticket Number with Airline Code",
    headerName: "Prod - Ticket Number with Airline Code",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Prod - Ticket Number with Airline Code"],
  },
  {
    field: "Prod - Booking Reference",
    headerName: "Prod - Booking Reference",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Prod - Booking Reference"],
  },
  {
    field: "Prod - Type (AIR,CAR,HOT,...)",
    headerName: "Prod - Type (AIR,CAR,HOT,...)",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Prod - Type (AIR,CAR,HOT,...)"],
  },
  {
    field: "Passenger First Name",
    headerName: "Passenger First Name",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Passenger First Name"],
  },
  {
    field: "Departure Date",
    headerName: "Departure Date",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Arrival date",
    headerName: "Arrival date",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Payment - UATP Type",
    headerName: "Payment - UATP Type",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Payment - UATP Type"],
  },
  {
    field: "Payment - CC Number",
    headerName: "Payment - CC Number",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Payment - CC Number"],
  },
  {
    field: "Prod - Confirmation no.",
    headerName: "Prod - Confirmation no",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Prod - Confirmation no."],
  },
  {
    field: "Pyment - CC pprovl code",
    headerName: "Pyment - CC pprovl code",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Pyment - CC pprovl code"],
  },
  {
    field: "Pyment - CC UTP pprovl code",
    headerName: "Pyment - CC UTP pprovl code",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Pyment - CC UTP pprovl code"],
  },
  {
    field: "Departure Code",
    headerName: "Departure Code",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Arrival Code",
    headerName: "Arrival Code",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    field: "Hotel - Name",
    headerName: "Hotel - Name",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Hotel - Name"],
  },
  {
    field: "Cust Ref - Department",
    headerName: "Cust Ref - Department",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Cust Ref - Department"],
  },
  {
    field: "Cust Ref - Cost Center",
    headerName: "Cust Ref - Cost Center",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Cust Ref - Cost Center"],
  },
  {
    field: "Cust Ref - Project Number",
    headerName: "Cust Ref - Project Number",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Cust Ref - Project Number"],
  },
  {
    field: "Cust Ref - Employee",
    headerName: "Cust Ref - Employee",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Cust Ref - Employee"],
  },
  {
    field: "Cust Ref - Order Number",
    headerName: "Cust Ref - Order Number",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Cust Ref - Order Number"],
  },
  {
    field: "Cust Ref - CD1",
    headerName: "Cust Ref - CD1",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Cust Ref - CD1"],
  },
  {
    field: "Cust Ref - CD2",
    headerName: "Cust Ref - CD2",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Cust Ref - CD2"],
  },
  {
    field: "Cust Ref - CD3",
    headerName: "Cust Ref - CD3",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Cust Ref - CD3"],
  },
  {
    field: "Cust Ref - CD4",
    headerName: "Cust Ref - CD4",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Cust Ref - CD4"],
  },
  {
    field: "Gross Amount CCC",
    headerName: "Gross Amount CCC",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Gross Amount CCC"],
    formatType: "AMOUNT",
  },
  {
    field: "GST CCC",
    headerName: "GST CCC",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["GST CCC"],
    formatType: "AMOUNT",
  },
  {
    field: "Net Amount CCC",
    headerName: "Net Amount CCC",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Net Amount CCC"],
    formatType: "AMOUNT",
  },
  {
    field: "TAX CCC",
    headerName: "TAX CCC",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["TAX CCC"],
    formatType: "AMOUNT",
  },
  {
    field: "Air - Airline",
    headerName: "Air - Airline",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    valueGetter: (p) => p.data["Air - Airline"],
  },
  {
    field: "Remarks",
    headerName: "Remarks",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
];

const items = [
  { key: "booking", label: "Booking Data" },
  // { key: "booking_work", label: "Booking Workaround" },
];

function TMCTable() {
  const [activeTab, setActiveTab] = useState("booking");
  const ref = useRef(null);

  return (
    <>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <PageHeader
          title="Travel Company"
          leftActions={
            <Tabs
              className="my-custom-tabs"
              items={items}
              activeKey={activeTab}
              onChange={setActiveTab}
              tabBarStyle={{ borderBottom: "none", margin: 0 }}
            />
          }
        />
        <div style={{ flex: 1, marginTop: "16px", height: "100%" }}>
          {activeTab === "booking" ? (
            <AgTableClient
              columnDefs={columnDefs1}
              rowData={sampleTMCBooking}
              ref={ref}
              groupPanel
            />
          ) : (
            <div style={{ flex: 1, marginTop: "16px", height: "100%" }}>
              <AgTableClient
                columnDefs={columnDefs2}
                rowData={sampleTMCBookingWork}
                ref={ref}
                groupPanel
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default TMCTable;
